module.exports = __webpack_public_path__ + "static/media/ac-dark-gray.43915ad3.svg";